// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmployeeContributionLimitResponse
 */
export interface IEmployeeContributionLimitResponse {
    /**
     * 
     * @type {number}
     * @memberof IEmployeeContributionLimitResponse
     */
    employee_id?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof IEmployeeContributionLimitResponse
     */
    plan_id_to_contribution_amount?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof IEmployeeContributionLimitResponse
     */
    plan_id_to_election_limit_amount?: { [key: string]: number; };
}

/**
 * Check if a given object implements the IEmployeeContributionLimitResponse interface.
 */
export function instanceOfIEmployeeContributionLimitResponse(value: object): value is IEmployeeContributionLimitResponse {
    return true;
}

export function IEmployeeContributionLimitResponseFromJSON(json: any): IEmployeeContributionLimitResponse {
    return IEmployeeContributionLimitResponseFromJSONTyped(json, false);
}

export function IEmployeeContributionLimitResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeContributionLimitResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'plan_id_to_contribution_amount': json['plan_id_to_contribution_amount'] == null ? undefined : json['plan_id_to_contribution_amount'],
        'plan_id_to_election_limit_amount': json['plan_id_to_election_limit_amount'] == null ? undefined : json['plan_id_to_election_limit_amount'],
    };
}

export function IEmployeeContributionLimitResponseToJSON(json: any): IEmployeeContributionLimitResponse {
    return IEmployeeContributionLimitResponseToJSONTyped(json, false);
}

export function IEmployeeContributionLimitResponseToJSONTyped(value?: IEmployeeContributionLimitResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'plan_id_to_contribution_amount': value['plan_id_to_contribution_amount'],
        'plan_id_to_election_limit_amount': value['plan_id_to_election_limit_amount'],
    };
}

